import { spreadModes } from '@/i18n';
import { t } from '@/i18n';
import type { SpreadMode } from '@/types';
import styles from './ModeSelector.module.css';

interface ModeSelectorProps {
  value: SpreadMode;
  onChange: (m: SpreadMode) => void;
}

export function ModeSelector({ value, onChange }: ModeSelectorProps) {
  return (
    <div className={styles.block}>
      <div className={styles.row} role="group" aria-label={t.spread.modeAria}>
        {spreadModes.map((m) => (
          <button
            key={m.id}
            type="button"
            className={[styles.card, value === m.id ? styles.active : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(m.id)}
          >
            <span className={styles.ico} aria-hidden>
              {m.icon}
            </span>
            <span className={styles.lbl}>{m.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
